/**
 * @Author:
 * @Description:
 * @DateTime: Created in 2021-03-25 19:15:18
 */

import ExceptionTask from '../exceptionTask';
import { default as CellOperate } from 'src/components/agGridComponent/cellOperate';
import { ColDefCustom, default as AgGridVueCustomTsx } from 'src/components/agGridCustom/agGridVueCustomTsx';
import ExceptionTaskApi, { ExceptionTaskDOI } from '../api/exceptionTaskApi';
import ListPageService from 'src/types/ListPage';
import override from 'src/dectorators/override';
import { QueryFormVOI } from 'src/components/queryForm/queryForm';
import CellRenderTsx from 'src/components/agGridComponent/cellRenderTsx';
import EnumOperates from 'src/enums/enumOperates';
import { EnumExceptionTaskStatus, EnumExceptionTaskDealStatus } from 'src/enums/enumExceptionStatus';
import CommonSelect from 'src/components/SelectCustom/commonSelect';
import Input from 'src/types/iview/Input';
import DatePicker from 'src/types/iview/DatePicker';
import { DateTimeUtil } from 'src/util/dateTimeUtil';
import alertOperateExceptionTaskModal from '../operateExceptionTaskModal';

export default class ExceptionTaskService extends ListPageService {
    ctx: ExceptionTask;

    // 是否是申报
    get isDistribute() {
        return this.ctx.$route.name === 'maintenance-manage-exception-task-dispatch';
    }

    constructor(ctx: ExceptionTask) {
        super();
        this.ctx = ctx;
    }

    @override
    createColumns(): ColDefCustom[] {
        let t = this;
        return [
            {
                headerName: '通知单号',
                field: 'inform_number',
                minWidth: 120,
            },
            {
                headerName: '任务号',
                field: 'task_number',
                minWidth: 120,
                cellRendererFramework: CellRenderTsx,
                cellRendererFrameworkOpt: {
                    cellRender(h, params) {
                        let data: ExceptionTaskDOI.RowDataI = params.data;
                        return (
                            <div
                                class="wqms-cursor wqms-link"
                                on-click={() => {
                                    alertOperateExceptionTaskModal(EnumOperates.Detail.getName(), data.id, data.device_id);
                                }}
                            >
                                {data.task_number}
                            </div>
                        );
                    },
                },
            },
            {
                headerName: '发起人',
                field: 'initiator',
                minWidth: 100,
            },
            {
                headerName: '发起时间',
                field: 'sponsor_datetime',
                minWidth: 170,
            },
            {
                headerName: '异常站点',
                field: 'device_name',
                minWidth: 140,
            },
            {
                headerName: '处理人',
                field: 'dispose_people',
                minWidth: 100,
            },
            {
                headerName: '处理时间',
                field: 'dispose_people',
                minWidth: 170,
            },
            {
                headerName: '状态',
                field: 'status',
                minWidth: 100,
                cellRenderer(params) {
                    let data: ExceptionTaskDOI.RowDataI = params.data;
                    return t.isDistribute
                        ? EnumExceptionTaskStatus.findId(data.ops_leader_status).getName()
                        : EnumExceptionTaskDealStatus.findId(data.dispose_condition).getName();
                },
            },
            {
                headerName: '操作',
                field: 'operate',
                minWidth: 120,
                maxWidth: 120,
                // pinned: 'right',
                cellRendererFramework: CellOperate,
                cellRendererFrameworkOpt: [
                    {
                        text: '派发任务',
                        hide: !t.isDistribute,
                        disabled(params) {
                            let data: ExceptionTaskDOI.RowDataI = params.data;
                            return EnumExceptionTaskStatus.待派发.getId() !== data.ops_leader_status;
                        },
                        async click(params) {
                            let data: ExceptionTaskDOI.RowDataI = params.data;
                            let res = await alertOperateExceptionTaskModal(EnumOperates.Distribute.getName(), data.id, data.device_id);
                            if (res) {
                                t.searchTable();
                            }
                        },
                    },
                    {
                        text: '处理',
                        hide: t.isDistribute,
                        disabled(params) {
                            let data: ExceptionTaskDOI.RowDataI = params.data;
                            return EnumExceptionTaskDealStatus.未处理.getId() !== data.dispose_condition;
                        },
                        async click(params) {
                            let data: ExceptionTaskDOI.RowDataI = params.data;
                            let res = await alertOperateExceptionTaskModal(EnumOperates.Deal.getName(), data.id, data.device_id);
                            if (res) {
                                t.searchTable();
                            }
                        },
                    },
                ],
            },
        ];
    }

    @override
    creatQueryForm(): QueryFormVOI.DateItemType[] {
        let t = this;
        return [
            {
                component: CommonSelect,
                label: '状态：',
                field: 'status',
                props: {
                    value: null,
                    dataSource: t.isDistribute ? EnumExceptionTaskStatus.getList() : EnumExceptionTaskDealStatus.getList(),
                },
            },
            {
                component: DatePicker,
                label: '发起时间',
                field: 'time',
                width: 300,
                timeType: 'number',
                realField: ['start_time', 'end_time'],
                props: { value: DateTimeUtil.getDayInterval(7), type: 'daterange', format: 'yyyy-MM-dd', placeholder: '请选择时间' },
            },
            {
                component: Input,
                labelWidth: 20,
                label: '',
                field: 'keyword',
                props: { value: '', placeholder: '请输入' },
            },
        ];
    }


    @override
    initSearchParams(): void {
        this.ctx.searchParams = this.ctx.queryForm.getQueryObj<ExceptionTaskDOI.QueryRowDataParamsI>();
        this.ctx.currentPage = 1;
    }

    @override
    async searchTable() {
        let ctx = this.ctx;
        let ag = this.ctx.$refs.ag as AgGridVueCustomTsx;
        ag.showLoading();
        let { code, data } = await ExceptionTaskApi.searchList({
            ...ctx.searchParams,
            page_size: ctx.pageSize,
            page_index: ctx.currentPage,
        }, this.isDistribute);
        ag.hideLoading();

        if (code === 0) {
            ctx.rowData = data.data_info || [];
            ctx.total = data.page_count;
        }
    }
}
